<template>
  <div :class="['coupon-discount-item' ,  current ? 'current' : '' ]">
    <div class="discount-title">
      <slot name="title">
        <span class="default">第{{index + 1}}单享</span>
      </slot>
    </div>
    <div class="discount-number">
      <div v-if="isFullAmount">
        <span class="key-word">{{ coupon.cash_reduce/100 }}</span><span class="p-t-2">元</span>
      </div>
      <div v-if="isFullOrder">
        <span class="key-word">{{ formatDiscount }}</span><span class="p-t-2">折</span>
      </div>
      <div v-if="isFreeOrder">
        <span class="p-t-2">免</span><span class="key-word">{{ coupon.reduce_num }}</span><span class="p-t-2">单</span>
      </div>

    </div>
    <div class="discount-threshold">
      <div>{{ getCondition }}</div>
    </div>
    <slot name="bottom"></slot>
  </div>
</template>


<script>
import utils from '@/libs/utils';


export default {
  components: {
  },
  props: {
    current: Boolean,
    type: String, 
    index: Number,
    coupon: {
      type: Object,
      default: () => ({
        discount: 10,
        desc: '满100可用',
      }),
    },
  },
  computed: {
    isFullAmount() {
      return this.coupon && this.coupon.coupon_type_id === 0;
    },
    isFullOrder() {
      return this.coupon && this.coupon.coupon_type_id === 1;
    },
    isFreeOrder() {
      return this.coupon && this.coupon.coupon_type_id === 2;
    },
    formatDiscount() {
      return utils.formatNumberWithDecimals(this.coupon.cash_reduce / 1000);
    },
    getCondition() {
      if (this.isFreeOrder) {
        return `满${this.coupon.reach_reduce_num}单可用`;
      } else if (this.coupon.reach_reduce) {
        return `满${this.coupon.reach_reduce / 100}元可用`;
      }
      return '无门槛';
    },
  },
  data() {
    return {
    };
  },
  watch: {
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
.coupon-discount-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url(../../../assets/imgs/activity/three-order-activity/discount-coupon-default.png) no-repeat center;
  background-size: 100% 100%;
  position: relative;
  color: #FEF7D8;
  font-size: 22px;
  width: 182px;
  height: 234px;
  transform-box: border-box;
  &.current {
    background: url(../../../assets/imgs/activity/three-order-activity/discount-coupon-current.png) no-repeat center;
    background-size: 100% 100%;
    opacity: 1;
    color: #E34236;
  }
  &:first-child {
    margin-left: 0;
  }
  .discount-title {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient( 180deg, #FFEEC6 0%, #FFD0B3 100%);
    border-radius: 0px 0px 28px 28px;
    color: #E34236;
    white-space: nowrap;
    line-height: 30px;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: center;
    padding: 2px 24px;
  }
  .discount-number {
    padding: 52px 0 68px;
    font-size: 28px;
    line-height: 40px;
    .p-t-2 {
      position: relative;
      top: -2px;
    }
    .key-word {
      font-size: 52px;
      font-weight: 600;
      line-height: 72px;
    }
  }
  .discount-threshold {
    line-height: 30px;
    color: #FEF7D8;
  }
  &.small {
    width: calc(182px * 0.9);
    height: calc(234px * 0.9);
  }
  &.big {
    width: calc(182px * 1.1);
    height: calc(234px * 1.1);
  }
}

.bottom {
  position: absolute;
}


// 权益中心特殊处理
.equity {
  .discount-box {


  }

}

</style>



// WEBPACK FOOTER //
// src/components/activity/coupon-item/coupon-discount-item.vue